module.exports = __webpack_public_path__ + "files/d63e61a41509b9961cf4fdf9738a4a26.svg";